import { Box, ListView } from '@razorpay/blade/components';
import React, { useState } from 'react';
import { DeductionsDetailView, DeductionsFilters, DeductionsListView } from './index';
import { StatusFilterKeyType } from 'components/SalaryComponents/components/filters/StatusFilter';

const DeductionsView = () => {
  const [counts, setCounts] = useState<Record<StatusFilterKeyType, number>>();

  return (
    <>
      <Box paddingX="spacing.8" marginTop="spacing.5">
        <ListView>
          <DeductionsFilters counts={counts} />
          <DeductionsListView onCountChange={setCounts} />
        </ListView>
        <DeductionsDetailView />
      </Box>
    </>
  );
};

export default DeductionsView;
